import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DynamicFormDto } from '../../../service/dto';
import { FormResult } from '../../../components/dynamic-form/dynamic-form.component';
import { HttpInsurancePremiumRecipientService } from '../../../service/http-insurance-premium-recipient.service';

@Component({
	selector: 'app-dynamic-generic-entity-form',
	standalone: false,
	templateUrl: './dynamic-generic-entity-form.component.html',
	styleUrl: './dynamic-generic-entity-form.component.scss'
})
export class DynamicGenericEntityFormComponent implements OnInit, OnDestroy {
	data?: DynamicFormDto;
	type!: string;
	name!: string;
	subscription = new Subscription();

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private httpService: HttpInsurancePremiumRecipientService) { }

	ngOnInit(): void {
		this.subscription.add(this.activatedRoute.paramMap.subscribe(paramMap => {
			this.type = paramMap.get('type')!;
			this.name = this.getName(this.type);
			const id = paramMap.get('id');
			if (id) {
				this.httpService.get(this.type, +id).subscribe(result => {
					this.data = result;
				});
			} else {
				this.httpService.getForm(this.type).subscribe(result => {
					this.data = result;
				});
			}
		}));
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
	doHandleResult(input: FormResult) {
		if (input.type == 'Cancel') {
			this.router.navigate(['/dynamic', this.type, 'list']);
			return;
		}
		(this.data?.id ? (this.httpService.edit(this.type, this.data.id, input.data)) : (this.httpService.create(this.type, input.data))).subscribe(result => {
			this.router.navigate(['/dynamic', this.type, 'list']);
		});
	}
	getName(type: string) {
		return type
			.split('_')
			.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
			.join(' ');
	}
}
